import { CellModel, RowModel } from "components/StentorUIComponents";
import React, { Dispatch, SetStateAction } from "react";
import { AppsTableCellContainer } from "../containers/AppsTableCellContainer";
import { ColumnIDs } from "../Types";

export interface AppsTableRowProps {
    readonly visibleColumns: readonly ColumnIDs[];
    readonly appId: string;
    readonly appIcon: string;
    readonly appName: string;
    readonly createdDate: string;
    readonly lastModifiedDate: string;
    readonly submitter: string;
    readonly status: string;
    readonly organizationId: string;
    readonly notes: string;
    onActionClick?(status: string, appId: string): void;
    showSnippetDialog: () => void;
    showSnippetDialogKey: (key: string) => void;
    setLoading: Dispatch<SetStateAction<boolean>>;
    valueNotes?: (note: string, id: string, status: string) => void
}

export function renderAppsTableRow(props: AppsTableRowProps): RowModel {
    const {
        visibleColumns,
        appId,
        appIcon,
        appName,
        createdDate,
        lastModifiedDate,
        submitter,
        status,
        organizationId,
        notes,
        onActionClick,
        showSnippetDialog,
        showSnippetDialogKey,
        setLoading,
        valueNotes
    } = props;

    const cells: CellModel[] = visibleColumns.map((columnId) => {
        return {
            cellContent: (
                <AppsTableCellContainer
                    key={columnId}
                    columnId={columnId}
                    appId={appId}
                    appIcon={appIcon}
                    appName={appName}
                    createdDate={createdDate}
                    lastModifiedDate={lastModifiedDate}
                    submitter={submitter}
                    status={status}
                    notes={notes}
                    onActionClick={onActionClick}
                    showSnippetDialog={showSnippetDialog}
                    organizationId={organizationId}
                    showSnippetDialogKey={showSnippetDialogKey}
                    setLoading={setLoading}
                    valueNotes={valueNotes}
                />
            )
        }
    });

    return { key: appId, cells };
}

